import type { StateCreator } from 'zustand'

export interface MyDeleteRefreshSlice {
  refetchMyDelete: boolean
  ignoreListRefetch?: Array<string>
  setRefetchMyDelete: (selected: boolean, ignoreListRefetch?: Array<string>) => void
}

export const createMyDeleteSlice: StateCreator<
  MyDeleteRefreshSlice,
  [],
  [],
  MyDeleteRefreshSlice
> = (set: Function) => ({
  refetchMyDelete: false,
  ignoreListRefetch: [],
  setRefetchMyDelete: (selected: boolean, ignoreListRefetch?: Array<string>) =>
    set({
      refetchMyDelete: selected,
      ignoreListRefetch: ignoreListRefetch || []
    })
})
